import { LitElement, html, nothing } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../types/common/types';
import _ from 'lodash';
import { translateFn } from '../../../utils/translator.helper';

/**
 * @summary Type here the description of this component
 * @tag custom-rules-targets
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('custom-rules-targets')
export class CustomRulesTargetsWebComponent extends LitElement {
  /**
   * See https://lit-element.polymer-project.org/guide/properties
   * Write here the description of this field
   */
  @property({ type: Object, attribute: false, reflect: false })
  rule;

  @property({ type: Object, attribute: false, reflect: false })
  _targets: string[];

  @state()
  isShowMorePresentNetwork = true;

  @state()
  displayedItems;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-title
        fontSize="${FontSizes.PARAGRAPH_11}"
        fontWeight="${FontWeights.SEMIBOLD}"
        class="section-title text-uppercase mb-2"
        >${translateFn('Targets')}</gz-title
      >
      <gz-labeled-content label=${translateFn('Network targets')} stacked>
        ${this.generateNetworkTargets()}
      </gz-labeled-content>
    `;
  }

  constructor() {
    super();
  }

  private generateNetworkTargets() {
    if ((this.rule.targets.companiesIds && (!this.rule.targets.companies || this.rule.targets.companies.length === 0)) ||
      (this.rule.targets.endpointTags && this.rule.targets.endpointTags.length === 0)) {
      return html`<gz-text class="network-groups" fontSize="12" fontWeight="500">${translateFn('None')}</gz-text>`;
    }

    return html` ${this.displayedItems.map(item => {
      return html`<gz-text class="network-groups" fontSize="12" fontWeight="500">${item}</gz-text>`;
    })}
    ${this.isShowMorePresentNetwork
      ? html` <gz-button
          class="show-more-btn"
          type="quiet"
          color="primary"
          buttonHeight="small"
          buttonFontSize="small"
          theme="light"
          @click="${this.showMoreNetwork}"
        >
          ${translateFn('Show more')}
        </gz-button>`
      : nothing}`;
  }

  get targets(): Array<string> {
    return this._targets;
  }

  set targets(prop: Array<string>) {
    if (!prop) {
      return;
    }
    const oldTargets = this._targets;
    this._targets = prop;
    if (this._targets.length > 3) {
      this.isShowMorePresentNetwork = true;
      this.displayedItems = this._targets.slice(0, 3);
    } else {
      this.displayedItems = _.clone(this._targets);
      this.isShowMorePresentNetwork = false;
    }

    this.requestUpdate('targets', oldTargets);
  }

  private showMoreNetwork() {
    this.isShowMorePresentNetwork = false;
    this.displayedItems = _.clone(this._targets);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'custom-rules-targets': CustomRulesTargetsWebComponent;
  }
}
